import type { Control, FieldPath, FieldValues } from "react-hook-form";
import { CheckboxField } from "@/components/fields/checkbox-field";

export interface CdcExplicitSmsConsentFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> extends React.HTMLAttributes<HTMLDivElement> {
  control: Control<TFieldValues>;
  name: TName;
  text: string;
}
// Renders a CDC explicit SMS marketing consent checkbox field.
// SMS marketing requires explicit (checkbox) opt-in consent. When the
// checkbox is left unticked the value resolves to false, which is stored
// as an explicit opt-out on the user's CDC profile.
export function CdcExplicitSmsConsentField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  control,
  name,
  className,
  text,
  ...htmlProps
}: Readonly<CdcExplicitSmsConsentFieldProps<TFieldValues, TName>>) {
  return (
    <CheckboxField
      control={control}
      name={name}
      label={text}
      className={className}
      {...htmlProps}
    />
  );
}
